module.exports = {
          srcSet: __webpack_public_path__ + "cfe42b7a22d4b095f267d60373263d90-196.png"+" 196w",
          images:[ {path: __webpack_public_path__ + "cfe42b7a22d4b095f267d60373263d90-196.png",width: 196,height: 235}],
          src: __webpack_public_path__ + "cfe42b7a22d4b095f267d60373263d90-196.png",
          toString:function(){return __webpack_public_path__ + "cfe42b7a22d4b095f267d60373263d90-196.png"},
          
          width: 196,
          height: 235
        }